import React from 'react';
import { Box, MenuItem, Select as SelectMUI, Typography } from '@mui/material';

export function Select({ label, options, value, handleChange }) {
  if (!options) return null;

  const onChange = (event) => {
    handleChange(event.target.value);
  };

  return (
    <Box sx={{ position: 'relative ' }}>
      {label ? (
        <Typography
          sx={{
            position: 'absolute',
            backgroundColor: 'white',
            borderRadius: '999px',
            top: 0,
            left: '5px',
            right: '5px',
            transform: 'translateY(-92%)',
            textAlign: 'center',
            fontSize: '0.8rem',
            paddingBlock: '3px',
            lineHeight: '1rem',
          }}
        >
          {label}
        </Typography>
      ) : null}

      <SelectMUI
        value={value}
        onChange={onChange}
        displayEmpty
        sx={{
          minWidth: '150px',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'primary.main',
          backgroundColor: 'select.background',
          borderRadius: '999px',
          fontWeight: 'bold',
          color: 'primary.main',
          '.MuiSelect-select': {
            paddingBlock: '6px',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem value={option.value} key={index}>
            {option.label}
          </MenuItem>
        ))}
      </SelectMUI>
    </Box>
  );
}
